import React from "react";

import MasiveUpdate from "components/Tvendo/Article/DataMaster/PriceList/MasiveUpdate/List";

export default function () {
  return <MasiveUpdate />;
}
